/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordSetChallengeOptions } from './PasswordSetChallengeOptions';
import {
    PasswordSetChallengeOptionsFromJSON,
    PasswordSetChallengeOptionsFromJSONTyped,
    PasswordSetChallengeOptionsToJSON,
    PasswordSetChallengeOptionsToJSONTyped,
} from './PasswordSetChallengeOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordSetChallenge
 */
export interface PasswordSetChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordSetChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordSetChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {PasswordSetChallengeOptions}
     * @memberof PasswordSetChallenge
     */
    options: PasswordSetChallengeOptions;
}



/**
 * Check if a given object implements the PasswordSetChallenge interface.
 */
export function instanceOfPasswordSetChallenge(value: object): value is PasswordSetChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function PasswordSetChallengeFromJSON(json: any): PasswordSetChallenge {
    return PasswordSetChallengeFromJSONTyped(json, false);
}

export function PasswordSetChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': PasswordSetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordSetChallengeToJSON(json: any): PasswordSetChallenge {
    return PasswordSetChallengeToJSONTyped(json, false);
}

export function PasswordSetChallengeToJSONTyped(value?: PasswordSetChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': PasswordSetChallengeOptionsToJSON(value['options']),
    };
}

